import { Analytics, tracking } from 'constants/index'
import { AnalyticsProps, ContactType } from 'typings'
import { ActivateStep } from 'typings/account'

export const steps = (isRecoverPassword: boolean, hasMounted: boolean): Record<ActivateStep, AnalyticsProps> | null => {
    if (hasMounted) {
        return {
            [ActivateStep.newPassword]: {
                ...Analytics.ActivateAccountStep.NewPassword,
                path: isRecoverPassword ? tracking.PATH_ACTIVATE_ACCOUNT.RESET_PASSWORD : tracking.PATH_ACTIVATE_ACCOUNT.MDM,
            },
            [ActivateStep.selectContact]: {
                ...Analytics.ActivateAccountStep.SelectContact,
                path: isRecoverPassword ? tracking.PATH_ACTIVATE_ACCOUNT.RESET_PASSWORD : tracking.PATH_ACTIVATE_ACCOUNT.MDM,
            },
            [ActivateStep.validateToken]: {
                ...Analytics.ActivateAccountStep.ValidateToken,
                path: isRecoverPassword ? tracking.PATH_ACTIVATE_ACCOUNT.RESET_PASSWORD : tracking.PATH_ACTIVATE_ACCOUNT.MDM,
            },
        }
    }
    return null
}

export const pageviews: Record<ActivateStep, AnalyticsProps> = {
    [ActivateStep.newPassword]: Analytics.ActivateAccountPageview.NewPassword,
    [ActivateStep.selectContact]: Analytics.ActivateAccountPageview.SelectContact,
    [ActivateStep.validateToken]: Analytics.ActivateAccountPageview.ValidateToken,
}

export const activateTrack = (isRecoverPassword: boolean, validationType?: ContactType): AnalyticsProps => {
    const register_validation: string = validationType === 'MOBILE' ? 'SMS' : (validationType as string)

    return {
        event: tracking.ACTIVATE_ACCOUNT_SUCCESS.EVENT,
        href: tracking.ACTIVATE_ACCOUNT_SUCCESS.HREF,
        path: isRecoverPassword ? tracking.PATH_ACTIVATE_ACCOUNT.RESET_PASSWORD : tracking.PATH_ACTIVATE_ACCOUNT.MDM,
        register_validation,
    }
}
